import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import auth from '../../utils/auth';
import ErrorBoundary from '../ErrorBoundary';
import { getInfo } from '../../modules/Auth/AuthActions';
import Header from '../Header/Header';
import Navigation from '../Navigation/Navigation';

class PrivateLayout extends Component {
  state = {
    navigationMenuOpened: true,
  };

  componentDidMount() {
    auth.checkForToken(
      () => {
        if (!this.props.user.email) {
          this.props.getInfo();
        } else if (
          this.props.admin &&
          this.props.user &&
          (!this.props.user.partner || this.props.user.partner.role !== 'owner')
        ) {
          this.props.history.replace('/');
        }
      },
      () => {
        this.props.history.replace('/login');
      }
    );
  }

  render() {
    const Component = this.props.component;
    const route = this.props.route;

    const { navigationMenuOpened } = this.state;

    return (
      <ErrorBoundary>
        <div className={`page-container ${navigationMenuOpened ? 'nav-open' : 'nav-close'}`}>
          <Navigation onMenuToggle={(isOpen) => this.setState({ navigationMenuOpened: isOpen })} />
          <div className='page-wrap'>
            <Header />
            <div className='page-content'>
              <Component route={route} />
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getInfo: () => dispatch(getInfo()),
  };
};

function mapStateToProps(state) {
  return {
    user: state.auth.user,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateLayout));
